import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

export const StyledTooltipHeader = styled(Flex)<{ backgroundColor: string }>`
    padding: 8px 10px 8px 8px;
    min-width: 270px;
    background: ${({ backgroundColor }) => backgroundColor || colorsPalettes.torquoise[50]};
    border-radius: 10px;
`;

export const StyledTooltipHeaderText = styled(Text)`
    font-weight: 600;
`;

export const StyledEmptyTooltipHeader = styled(Flex)`
    padding: 4px 0;
    flex: 1 0 0;
`;
